(() => {
  function init(root) {
    if (!root || root.dataset.cbfpReady) return;
    root.dataset.cbfpReady = 'true';
    const tabs = root.querySelector('[data-cbfp-tabs]');
    if (!tabs) return;
    const links = [...tabs.querySelectorAll('[data-cbfp-tab]')];
    const panels = [...tabs.querySelectorAll('[data-cbfp-panel]')];
    tabs.querySelector('.cbfp-tabs__nav').setAttribute('role', 'tablist');
    links.forEach((link, i) => {
      link.id = `cbfp-tab-${root.id}-${i}`;
      link.setAttribute('role', 'tab');
      link.setAttribute('aria-controls', panels[i].id);
      panels[i].setAttribute('role', 'tabpanel');
      panels[i].setAttribute('aria-labelledby', link.id);
      panels[i].tabIndex = 0;
    });
    const activate = (index, focus = false) => {
      links.forEach((link, i) => {
        const selected = i === index;
        link.setAttribute('aria-selected', String(selected));
        link.tabIndex = selected ? 0 : -1;
        panels[i].hidden = !selected;
      });
      if (focus) links[index].focus();
    };
    links.forEach((link, i) => {
      link.addEventListener('click', event => { event.preventDefault(); activate(i); });
      link.addEventListener('keydown', event => {
        let index;
        if (event.key === 'ArrowRight') index = (i + 1) % links.length;
        if (event.key === 'ArrowLeft') index = (i + links.length - 1) % links.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = links.length - 1;
        if (index !== undefined) { event.preventDefault(); activate(index, true); }
      });
    });
    root.querySelectorAll('[data-cbfp-review-link], [data-cbfp-write-review]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        activate(2);
        const details = panels[2].querySelector('details');
        if (link.hasAttribute('data-cbfp-write-review')) details.open = true;
        panels[2].scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    });
    root.querySelectorAll('.cbfp-stars').forEach(group => {
      const inputs = [...group.querySelectorAll('input')];
      group.addEventListener('change', () => {
        const selected = inputs.findIndex(input => input.checked);
        inputs.forEach((input, i) => { input.nextElementSibling.textContent = i <= selected ? '★' : '☆'; });
      });
    });
    const current = panels.findIndex(panel => '#' + panel.id === location.hash);
    activate(current >= 0 ? current : 0);
    if (tabs.querySelector('.errors, [role="status"]')) {
      activate(2);
      panels[2].querySelector('details').open = true;
    }
  }
  document.querySelectorAll('.cbfp').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cbfp').forEach(init));
})();
